module.exports = __webpack_public_path__ + "static/flags/MK-70bf7a54bd0820cb1286cdad5cbba0bc.gif";